import { RecursiveDiff } from '@skylab-shared/types';
import { ObservableCollection } from '../../observable';
import { ModelBase } from './model-base';
import { ModelMetadataContainer } from './model-metadata-container';

export class ModelSerializer {
    public static toPlainObject<TModel extends ModelBase>(model: TModel): RecursiveDiff<TModel, ModelBase> {
        const modelMetadataContainer = <ModelMetadataContainer>Reflect.getOwnMetadata('skl:model', model.constructor);
        return <RecursiveDiff<TModel, ModelBase>>(modelMetadataContainer?.properties
            ? modelMetadataContainer?.properties.map(({ propertyName }) => [propertyName, (model as any)[propertyName]])
                .reduce<Record<string, unknown>>((result, [propertyName, propertyValue]) => {
                    if (propertyValue instanceof ModelBase) {
                        result[propertyName] = this.toPlainObject(propertyValue);
                    } else if (propertyValue instanceof ObservableCollection || propertyValue instanceof Array) {
                        result[propertyName] = propertyValue.map(m => this.toPlainObject(m));
                    } else {
                        result[propertyName] = propertyValue;
                    }
                    return result;
                }, {})
            : model);
    }
}
